import React from "react";
import "./IndustriesTheme.css";
import EngineeringPage from "./EngineeringPage";
const data = {
  "title": "Industries",
  "sections": [
    {
      "label": "Hero",
      "title": "Industries We Enable",
      "paragraphs": [
        "Semiconductor innovation powers nearly every modern industry—but the engineering challenges behind each application are fundamentally different. From automotive and artificial intelligence to networking, industrial automation, healthcare, consumer electronics, and data center technologies, every product demands a unique combination of performance, reliability, scalability, and compliance.",
        "At Digicomm Semiconductor, we combine deep semiconductor engineering expertise with an understanding of industry-specific requirements to develop purpose-built engineering solutions. Our multidisciplinary teams work across the silicon development lifecycle, helping customers transform complex engineering challenges into reliable, high-performance semiconductor products."
      ],
      "cards": [],
      "cta": "Discuss Your Engineering Challenge"
    },
    {
      "label": "Industry Ecosystem",
      "title": "Semiconductor Engineering Across Diverse Industries",
      "paragraphs": [
        "Every industry places unique demands on semiconductor products. Performance, reliability, power efficiency, safety, connectivity, scalability, and lifecycle expectations vary significantly depending on the application. Digicomm Semiconductor brings multidisciplinary engineering expertise together with industry understanding to help customers develop silicon solutions that meet these specialized requirements."
      ],
      "cards": [
        {
          "title": "Automotive",
          "focus": "Functional Safety • ADAS • EV Electronics • High-Reliability SoCs",
          "applications": "Advanced Driver Assistance Systems, Electric Vehicles, Infotainment, Body Electronics, Powertrain Systems"
        },
        {
          "title": "Artificial Intelligence & High-Performance Computing",
          "focus": "High-Performance Compute • AI Accelerators • Memory Subsystems • High-Speed Interconnects",
          "applications": "AI Training, AI Inference, Data Center Compute, Edge AI, Machine Learning Platforms"
        },
        {
          "title": "Networking & Telecommunications",
          "focus": "High-Speed Interfaces • Packet Processing • Low Latency • Connectivity Solutions",
          "applications": "5G Infrastructure, Ethernet Switching, Optical Networking, Wireless Connectivity, Network Processors"
        },
        {
          "title": "Consumer Electronics",
          "focus": "Low-Power Design • Multimedia Processing • Connectivity • Imaging",
          "applications": "Smartphones, Wearables, Smart Home Devices, AR/VR, Consumer Multimedia"
        },
        {
          "title": "Industrial Automation",
          "focus": "Real-Time Processing • Edge Computing • Industrial Connectivity • Reliability",
          "applications": "Factory Automation, PLC Systems, Robotics, Industrial IoT, Smart Manufacturing"
        },
        {
          "title": "Healthcare & Medical Electronics",
          "focus": "Precision • Reliability • Low-Power Systems • Medical Compliance",
          "applications": "Medical Imaging, Patient Monitoring, Portable Medical Devices, Diagnostic Equipment"
        }
      ]
    },
    {
      "label": "Engineering with Industry Context",
      "title": "Engineering Expertise Guided by Industry Context",
      "paragraphs": [
        "Semiconductor engineering disciplines may remain consistent across projects, but the expectations placed on those disciplines vary significantly from one industry to another. Success depends not only on technical capability but also on understanding the priorities that define each application.",
        "At Digicomm Semiconductor, our multidisciplinary engineering teams adapt their approach to align with the performance, reliability, safety, compliance, and lifecycle expectations of the industries we serve. This enables us to develop engineering solutions that are technically robust and contextually relevant."
      ],
      "cards": [],
      "priorities": [
        [
          "Automotive",
          "Functional Safety, Reliability, Long Product Lifecycle"
        ],
        [
          "Artificial Intelligence & HPC",
          "Performance, Scalability, Memory Bandwidth, Power Efficiency"
        ],
        [
          "Networking & Telecommunication",
          "High-Speed Connectivity, Low Latency, Throughput"
        ],
        [
          "Consumer Electronics",
          "Power Optimization, User Experience, Product Integration"
        ],
        [
          "Industrial Automation",
          "Robustness, Real-Time Processing, Long-Term Reliability"
        ],
        [
          "Healthcare & Medical Electronics",
          "Precision, Compliance, Reliability, Low-Power Operation"
        ]
      ]
    },
    {
      "label": "Engineering Approach",
      "title": "Engineering That Adapts to Every Industry",
      "paragraphs": [
        "While industries differ in their technical requirements, successful semiconductor engineering is built on the same fundamentals—strong engineering discipline, cross-functional collaboration, execution consistency, and a commitment to quality. At Digicomm Semiconductor, these principles form the foundation of every engagement, enabling our teams to adapt confidently to diverse technologies, products, and market requirements."
      ],
      "cards": [
        {
          "title": "Multidisciplinary Engineering Expertise",
          "text": "Integrated capabilities across design, verification, physical design, DFT, validation, embedded software, hardware platforms, and design automation."
        },
        {
          "title": "Scalable Engagement Models",
          "text": "Flexible engineering support tailored to project scope, team size, development stage, and execution requirements."
        },
        {
          "title": "Execution with Engineering Discipline",
          "text": "Structured engineering processes, quality-driven execution, and coordinated project delivery throughout the silicon development lifecycle."
        },
        {
          "title": "Technology Agility",
          "text": "Experience supporting a wide range of semiconductor technologies, architectures, and application domains."
        },
        {
          "title": "Collaborative Customer Engagement",
          "text": "Engineering teams that integrate seamlessly with customer organizations, enabling transparent communication and efficient execution."
        },
        {
          "title": "Focus on Reliable Outcomes",
          "text": "A consistent commitment to delivering engineering solutions that support product quality, performance, and long-term success."
        }
      ]
    },
    {
      "label": "Partnership Philosophy",
      "title": "Enabling Engineering Success Across Industries",
      "paragraphs": [
        "Every successful semiconductor product is shaped by the demands of the industry it serves and the strength of the engineering behind it. As technologies evolve and market expectations continue to grow, organizations need engineering partners who can adapt to changing requirements while maintaining consistency in execution.",
        "At Digicomm Semiconductor, we work alongside our customers to support engineering programs with technical expertise, collaborative execution, and a disciplined approach to product development. Whether contributing to a specific engineering function or supporting broader silicon development initiatives, our focus remains the same—helping customers build reliable semiconductor products with confidence."
      ],
      "cards": [],
      "cta": "Discuss Your Engineering Challenge"
    }
  ]
};
export default function IndustriesPage() { return <div className="industries-page"><EngineeringPage data={data} /></div>; }
